import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Col } from 'react-bootstrap'
import abrcBanner from './images/abrc-banner-small.png'

/**
 * Header used on for non-specialized pages
 * e.g. those pages that are not part of the landing-elements
 */
export default class SmallHeader extends Component {
  /**
   * Render component
   */
  render () {
    const smallHeaderStyle = {
      paddingTop: 22,
      overflow: 'auto'
    }

    const bannerImgStyle = {
      height: '100%',
      width: '100%',
      maxHeight: 224,
      maxWidth: 566
    }
    return (
      <header style={smallHeaderStyle}>
        <Col xs={0} sm={1} />
        <Col xs={12} sm={11}>
          <Link to='/'>
            <img
              style={bannerImgStyle}
              src={abrcBanner}
              alt='Americas Best Retirement Calculator'
            />
          </Link>
        </Col>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SmallHeader.js